import { Card, CardHeader, CardBody, Table } from "reactstrap";
import { API_BASE_URL } from "../../api/api";

export const CardProductOrder = ({ order }) => {
  if (!order?.items?.length) return null;

  const totalRoyalty = order.items.reduce(
    (acc, item) => acc + (item.loyalty_points * item.quantity),
    0
  );
  const totalBonus = order.items.reduce(
    (acc, item) => acc + (item.influencer_bonus * item.quantity),
    0
  );

  return (
    <Card className="shadow-sm mt-4">
      <CardHeader tag="h5">Productos</CardHeader>
      <CardBody>
        <Table responsive className="align-middle">
          <thead className="table-light">
            <tr>
              <th>#</th>
              <th>Imágenes</th>
              <th>Producto</th>
              <th>Cantidad</th>
              <th>Precio</th>
              <th>Regalía</th>
              <th>Bono</th>
            </tr>
          </thead>
          <tbody>
            {order.items.map((item, index) => {
              const product = item.product_id;         
              return (
                <tr key={item.id}>
                  <td>{index + 1}</td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "8px",
                        overflowX: "auto",
                        maxWidth: "250px",
                      }}
                    >
                      <img
                          src={`${API_BASE_URL}/product/get/file/${product.images[product.mainImage] || product.images[0]}`}
                          alt={`img`}
                          style={{
                            width: "60px",
                            height: "60px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            boxShadow: "0 0 4px rgba(0,0,0,0.1)",
                          }}
                        />
                    </div>
                  </td>
                  <td>{product.title}</td>
                  <td>{item.quantity}</td>
                  <td>${item.price.toLocaleString()}</td>
                  <td>{item.loyalty_points * item.quantity}</td>
                  <td>{item.influencer_bonus * item.quantity}</td>
                </tr>
              );
            })}

            <tr className="table-light fw-bold">
              <td colSpan={5} className="text-end">
                Totales:
              </td>
              <td>{totalRoyalty}</td>
              <td>{totalBonus}</td>
            </tr>
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};
